/* eslint-disable */

(function ($, Drupal) {
  Drupal.behaviors.filterButtons = {
    attach: function (context, settings) {
      $('.listing-filters')
        .once('activeFilterButtons')
        .each(function () {
          const urlParams = new URLSearchParams(window.location.search);
          const $activeFiltersDiv = $('.active-filters');

          const formIds = [
            'views-exposed-form-documents-page-1',
            'views-exposed-form-organisations-page-1',
            'views-exposed-form-news-page-1',
            'views-exposed-form-projects-page-1',
            'views-exposed-form-events-page-1',
            'views-exposed-form-events-page-2',
          ];

          formIds.forEach((formId) => {
            const $form = $('#' + formId, context);

            if ($form.length) {
              // search filters
              const combineValue = urlParams.get('combine');
              if (combineValue) {
                const $btn = createButton(combineValue, 'combine', true);
                $activeFiltersDiv.append($btn);
              }

              // Dropdown filters
              $form.find('select').each(function () {
                const $select = $(this);
                const selectName = $select.attr('name');
                const selectLabel = $select.parents('.js-form-type-select').find('.form-item__label').text();

                // No sort
                if (selectName.startsWith('sort')) {
                  return true;
                }

                const currentValue = urlParams.get(selectName);

                if (currentValue && currentValue !== 'All') {
                  const optionText = $select.find('option[value="' + currentValue + '"]').text();
                  const $btn = createButton(optionText, selectName, false, selectLabel);
                  $activeFiltersDiv.append($btn);
                }
              });
            }
          });

          if ($activeFiltersDiv.children().length) {
            const $clearAllBtn = $('<button type="button" class="clear-all">Clear all filters</button>');
            $clearAllBtn.click(function () {
              window.location = window.location.pathname;
            });
            $activeFiltersDiv.append($clearAllBtn);
            $activeFiltersDiv.addClass('has-active-filters');
          }
        });

      function createButton(text, filterName, isSearch, filterLabel) {
        const $btn = $(
          '<button type="button" class="active-filter" data-filter="' +
            filterName +
            '">' +
            (filterLabel ? filterLabel + ': ' : '') +
            (isSearch ? ' Search: "' : '') +
            text +
            (isSearch ? '"' : '') +
            '<span class="close">✕</span></button>',
        );

        $btn.click(function () {
          const arr = [
            'combine',
            'field_publication_year_value',
            'field_news_related_projects_target_id',
            'field_news_fund_target_id',
            'field_organisation_target_id',
            'field_country_target_id',
            'field_event_related_project_target_id',
            'field_event_location_text_value',
          ];

          if (arr.includes(filterName)) {
            updateUrlParameter(filterName, '');
          } else {
            updateUrlParameter(filterName, 'All');
          }
        });

        return $btn;
      }

      function updateUrlParameter(param, value) {
        let url = new URL(window.location.href);
        url.searchParams.set(param, value);
        window.location.href = url.toString();
      }
    },
  };
})(jQuery, Drupal);

function handleMobileFilters() {
  const breakpoint = window.matchMedia('(max-width: 1023px)');
  const btnFilter = document.querySelector('.btn-filter-mobile');
  const btnClose = document.querySelector('.btn-close-filters');

  const filterForm = document.querySelector('.listing-filters__form');

  if (!filterForm || !btnFilter || !btnClose) return;

  function closeFilter() {
    filterForm.classList.remove('active');
    document.body.classList.remove('not-scrollable');
  }

  btnFilter.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    filterForm.classList.add('active');
    document.body.classList.add('not-scrollable');
    console.log('enter hit');
  });

  btnClose.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeFilter();
  });

  breakpoint.addEventListener('change', () => {
    if (!breakpoint.matches) {
      closeFilter();
    }
  });
}

function resourcesFilters() {
  const pageBanner = document.querySelector('.page-banner__content');
  const resourcesBlock = document.querySelector('.featured-resources-block');

  if (!resourcesBlock || !pageBanner) return;
  let pageBannerHeight = Math.round(pageBanner.getBoundingClientRect().height);

  resourcesBlock.style.setProperty('--margin-top', `${pageBannerHeight}px`);

  window.addEventListener('resize', () => {
    pageBannerHeight = Math.round(pageBanner.getBoundingClientRect().height);
    resourcesBlock.style.setProperty('--margin-top', `${pageBannerHeight}px`);
  });
}

window.addEventListener('load', () => {
  handleMobileFilters();
  resourcesFilters();
});
